export default __webpack_public_path__ + "static/media/deskStorage.975fb687.svg";